import { customerList } from './../../system/customerManage/request';
import { logList } from './request';
export default {
  data() {
    return {
      form: {
        customerId: '',
        mark: '',
        createAt: '',
        operator: ''
      },
      data: [],
      customerList: [],
      columns: [{
        slots: {
          title: '日志编号'
        },
        dataIndex: 'id',
        key: '1',
        align: 'center',
        width: 100
      }, {
        slots: {
          title: '操作人'
        },
        dataIndex: 'operator',
        key: '2',
        align: 'center',
        ellipsis: true,
        width: 200
      }, {
        slots: {
          title: '权限标识'
        },
        dataIndex: 'mark',
        key: '3',
        align: 'center',
        width: 200
      }, {
        slots: {
          title: '操作内容'
        },
        dataIndex: 'content',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '操作时间'
        },
        dataIndex: 'createAt',
        key: '7',
        align: 'center',
        width: 200,
        ellipsis: true
      }],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      }
    };
  },
  created() {
    customerList({
      page: 1,
      pageSize: 10000
    }).then(res => {
      this.customerList = res.items;
      this.form.customerId = res.items[0].id;
      this.getDataFun();
    });
  },
  methods: {
    onChange(date, dateString) {
      this.form.createAt = this.form.createAt ? this.form.createAt : '';
      this.getDataFun();
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    getLogTable() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = this.form;
      Object.assign(obj, {
        page: this.pagination.current,
        pageSize: this.pagination.pageSize
      });
      logList(obj).then(res => {
        this.pagination.total = res.totalNum;
        this.data = res.items;
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].componentOptions.propsData.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};